<template>
  <va-sidebar :width="width" :minimized="minimized" :minimizedWidth="minimizedWidth">
    <menu-minimized v-if="minimized" :items="items" />
    <menu-accordion v-else :items="items" />
  </va-sidebar>
</template>


<script>
import { useGlobalConfig } from 'vuestic-ui';
import MenuAccordion from './menu/MenuAccordion.vue';
import MenuMinimized from './menu/MenuMinimized.vue';
import NavigationRoutes from './NavigationRoutes';
import { mapState, mapActions } from 'vuex';
import { defaultMenuItems, educationMenuItems } from '@/shared/menu-items';

export default {
  name: "app-sidebar",
  components: {
    MenuAccordion,
    MenuMinimized,
  },
  props: {
    width: { type: String, default: '18rem' },
    color: { type: String, default: "primary" },
    minimized: { type: Boolean, required: true },
    minimizedWidth: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      items: [],
      default_items: [],
      reports_items: [],
      download_items: [],
      export_items: [],
    };
  },
  computed: {
    ...mapState({
      userAuth: state => state.user.auth,
      permissionList: state => state.user.permissionList,
      specialPermissionList: state => state.user.specialPermissionList,
      selectedEntity: state => state.user.selectedEntity,
      entityLookUpList: state => state.user.entityLookUpList,
      availableReports: state => state.report.availableReports,
      availableDownloads: state => state.download.availableDownloads,
      availableExports: state => state.powerbiExport.availableExports,
    }),
    computedClass() {
      return {
        "app-sidebar--minimized": this.minimized,
      };
    },
    colors() {
      return useGlobalConfig().getGlobalConfig().colors
    },
    items() {
      const reportItems = JSON.parse(JSON.stringify(this.reports_items));
      const downloadItems = JSON.parse(JSON.stringify(this.download_items));
      const exportItems = JSON.parse(JSON.stringify(this.export_items));
      const defaultItems = JSON.parse(JSON.stringify(this.default_items));

      const merged = defaultItems.concat(...reportItems, ...downloadItems, ...exportItems)

      return [...merged]
    },
  },
  async created() {
    if (this.selectedEntity.id) {
      this.getReportList(this.selectedEntity.id)
      this.getDownloadList(this.selectedEntity.id)
      this.getExportList(this.selectedEntity.id)
      this.getDefaultMenu(this.selectedEntity.industry_name)
      // this.default_items = NavigationRoutes.routes;//this.getDefaultMenu(this.selectedEntity.industry_name)
    }
  },
  watch: {
    selectedEntity(newValue, oldValue) {
      if (newValue) {
        this.reports_items = [];
        this.getReportList(newValue.id)
        this.download_items = [];
        this.getDownloadList(newValue.id)
        this.export_items = [];
        this.getExportList(newValue.id)
        this.default_items = [];
        this.getDefaultMenu(newValue.id)

      }
    },
    availableReports(newValue) {
      const categories = Object.keys(newValue);
      const reports = [];
      categories.forEach(c => {
        const cate = { name: 'report', displayName: `${c} `, meta: { icon: 'entypo entypo-folder' }, params: { codename: null } }
        cate.children = [];
        newValue[c].forEach(r => {
          const report = { name: `report`, tag: `report/${r.codename}`, displayName: `${r.name}`, params: { codename: `${r.codename}` }, meta: { icon: 'entypo entypo-folder' } }
          cate.children.push(report)
        })
        reports.push(cate)
      })
      this.reports_items = reports;
    },
    availableDownloads(newValue) {
      let downloads = []
      if (newValue.length > 0) {
        let download_cate = { name: 'download', displayName: `Download`, params: { download_id: null, download_name: null, }, meta: { icon: 'entypo entypo-download' } }
        download_cate.children = []
        for (let i = 0; i < newValue.length; i++) {
          const id = newValue[i].id;
          const name = newValue[i].name;
          let report = { name: 'download', tag: `download/${id}`, displayName: `${name}`, params: { download_id: `${id}`, download_name: `${name}` }, meta: { icon: 'entypo entypo-download' } }
          download_cate.children.push(report);
        }
        downloads.push(download_cate);
      }
      this.download_items = downloads;
    },
    availableExports(newValue) {
      let exports = []
      if (newValue.length > 0) {
        let export_cate = { name: 'export', displayName: `Export `, meta: { iconClass: 'entypo entypo-export' } }
        export_cate.children = []
        for (var i = 0; i < newValue.length; i++) {
          var id = newValue[i].id;
          var name = newValue[i].name;
          let report = { name: 'export', displayName: `${name}`, params: { export_id: `${id}`, export_name: `${name}` }, meta: { iconClass: 'vuestic-iconset vuestic-iconset-files' } }
          export_cate.children.push(report);
        }
        exports.push(export_cate);
      }

      this.export_items = exports;
    },
  },
  methods: {
    ...mapActions({
      getReportList: "report/getReportList",
      getDownloadList: "download/getDownloadList",
      getExportList: "powerbiExport/getExportList",
    }),
    getDefaultMenu(industryName) {
      const defaultItems = this.checkPermissionsForNavigationRoutes(NavigationRoutes.routes);
      // const menu = [defaultMenuItems.routes, educationMenuItems.routes];
      // return menu;
      this.default_items = defaultItems;
      return
    },
    checkPermissionsForNavigationRoutes(routes) {

      const mapRoute = {
        name: 'maps',
        displayName: 'Demographic Analysis',
        meta: {
          icon: 'vuestic-iconset-maps',
          // requiresAuth: true,
          requiresPermission: 'view_demographics'
        },
        disabled: true,
      }
      const benchmarkRoute = {
        name: 'benchmark_report',
        displayName: 'Benchmark',
        meta: {
          icon: 'entypo entypo-chart-bar',
          // requiresAuth: true,
          requiresPermission: 'view_benchmark_report'
        },
        disabled: true,
      }

      const permissionListLength = JSON.parse(JSON.stringify(this.permissionList)).length;
      const specialPerimssionListLength = JSON.parse(JSON.stringify(this.specialPermissionList)).length;
      let permissions = [];
      if (specialPerimssionListLength === 0) {
        permissions = Object.values(this.permissionList)[0];
      } else (
        permissions = Object.values(this.specialPermissionList)
      )

      //remove demographics if not permitted
      if (permissions.indexOf('view_demographics') === -1) {
        let index = routes.findIndex(object => {
          return object.name === 'map';
        });
        routes.splice(index, 1)
      }
      // remove dashboard if not permitted
      if (permissions.indexOf('view_dashboard') === -1) {
        let index = routes.findIndex(object => {
          return object.name === 'dashboard';
        });
        routes.splice(index, 1)
      }
      //remove benchmark_report if not permitted
      if (permissions.indexOf('view_benchmark_report') === -1) {
        let index = routes.findIndex(object => {
          return object.name === 'benchmark_report';
        });
        routes.splice(index, 1)
      }

      return routes;
    }
  },
};
</script>

<style lang="scss">
.va-sidebar {
  width: 18rem !important;
  font-size: 14px;

  .va-sidebar-minimized {
    width: auto !important;
  }

  .va-collapse__body {
    margin-top: 0 !important;
  }

  &__menu {
    padding: 2rem 0;

    &__inner {
      padding-bottom: 8rem;
    }
  }

  &-item {
    border-radius: 0px 20px 20px 0px;

    &-content {
      padding: 0.75rem 0.5rem;
      color: white;

    }

    &__icon {
      width: 1.5rem;
      height: 1.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>

<style lang="scss" scoped>
.va-sidebar {
  flex-shrink: 0;
}

.va-sidebar--minimized {
  width: auto !important;
}
</style>
